module.exports = __webpack_public_path__ + "img/lupa.4d1bde9a.svg";